<template>
	<div class="orderdetails">
		<div :class="type == 'seller'?'otitle otitle1':'otitle'">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div v-if="type == 'buyer'">渠道: {{mydata.shop.shop_name}} （{{mydata.shop.qq}}）</div>
			<div v-if="type == 'seller'">渠道: {{mydata.shop.shop_name}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
			<div v-if="type == 'seller'">代理QQ: {{mydata.buy_user.qq}}</div>
		</div>
		<div class="table">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class" :row-class-name="tableRowClassName">
				<el-table-column label="图片" align="center" header-align="center" width="90px" class-name="default1">
					<template slot-scope="scope">
						<img class="img" :src="onimgarr(scope.row.product_pic)[0]" v-if="scope.row.product_pic">
					</template>
				</el-table-column>
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="100px">
					 <template slot-scope="scope">
					 	<div @click="oncopy(scope.row.product_style_number)">{{scope.row.product_style_number}}</div>
					 </template>
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_barcode" label="条码" align="center" header-align="center" width="150px">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="stock" label="下单前库存" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<!-- 配货中 -->
				<!-- true_num -->
				<el-table-column label="实发数量" align="center" header-align="center"
					v-if="type == 'seller'&& mydata.order.order_status == 3" width="160px">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.true_num" @change="handleChange($event,scope.row.id)"
							:min="0" :max="scope.row.num" size="small"></el-input-number>
					</template>
				</el-table-column>
				<!-- loufa_time > 0 -->
				<!--num>true_num标黄 -->
				<!-- 下单数>实发数 -->
				<el-table-column align="center" header-align="center" v-if="mydata.order.loufa_time > 0" width="110px">
					<template slot="header" slot-scope="scope">
						<div>实发数</div>
						<div>(原实发/漏发)</div>
					</template>
					<template slot-scope="scope">
						<div>{{scope.row.true_num}}</div>
						<div>({{scope.row.old_true_num}}/{{scope.row.old_true_num-scope.row.true_num}})</div>
					</template>
				</el-table-column>
				
				<el-table-column label="漏发数量" align="center" header-align="center" v-if="loufashow" width="160px"
					label-class-name="lf">
					<template slot-scope="scope">
						<el-input-number v-model="lflist[scope.$index].num" :min="0" :max="scope.row.num" size="small">
						</el-input-number>
					</template>
				</el-table-column>

				<el-table-column prop="product_price" label="吊牌价" align="center" header-align="center">
				</el-table-column>
				
				<el-table-column prop="total_scale" label="重量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="total_true_scale" label="实发重量" align="center" header-align="center">
				</el-table-column>

				<el-table-column prop="discount_for_buyer" label="折扣" align="center" header-align="center"
					v-if="type == 'buyer'">
				</el-table-column>
				<el-table-column prop="price_for_buyer" label="折扣价" align="center" header-align="center"
					v-if="type == 'buyer'">
				</el-table-column>
				<el-table-column prop="discount_for_seller" label="结算折扣" align="center" header-align="center"
					v-if="type == 'seller'">
				</el-table-column>
				<el-table-column prop="price_for_seller" label="结算单价" align="center" header-align="center"
					v-if="type == 'seller'">
				</el-table-column>
				<el-table-column prop="total_price_for_seller" label="结算金额" align="center" header-align="center"
					v-if="type == 'seller'">
				</el-table-column>
				<el-table-column prop="total_true_price_for_seller" label="实发结算金额" align="center" header-align="center"
					v-if="type == 'seller'" width="120px">
				</el-table-column>
			</el-table>

			<div class="statistics" v-if="type == 'buyer'">
				{{mydata.order.tips_for_buyer}}
			</div>
			<div class="statistics" v-if="type == 'seller'">
				{{mydata.order.tips_for_seller}}
			</div>
			
			<!-- 已发货 已成交-->
			<div class="statistics" v-if="mydata.order.order_status > 3 && mydata.order.order_status < 11 && mydata.order.order_status!=9 && type == 'buyer'">
				{{mydata.order.tips_true_for_buyer}}
			</div>
			<div class="statistics" v-if="mydata.order.order_status > 3 && mydata.order.order_status < 11 && mydata.order.order_status!=9 && type == 'seller'">
				{{mydata.order.tips_true_for_seller}}
			</div>

			<!-- loufa_time <= 0 -多件漏发 已发货-> -->
			<div class="item" v-if="type == 'seller' && mydata.order.loufa_time == 0 && mydata.order.order_status == 4">
				<div class="btns">
					<el-button class="red" type="primary" @click="onloufa()" size="small" v-if="!loufashow">修改漏发数量
					</el-button>
					<el-button size="small" v-if="loufashow" @click="oncancel">取消</el-button>
					<el-button type="primary" size="small" v-if="loufashow" @click="onsubloufa()">确认</el-button>
				</div>
			</div>

			<div class="item">
				<div class="ohead">
					渠道信息
				</div>
				<div class="itable">
					<div class="qdtable">
						<div class="lh">渠道退货地址</div>
						<div class="rv">
							{{mydata.shop.return_name}}
							{{mydata.shop.return_mobile}}
							{{mydata.shop.return_province}}
							{{mydata.shop.return_city}}
							{{mydata.shop.return_area}}
							{{mydata.shop.return_address}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">免费退货比例+超出扣款</div>
						<div class="rv">
							{{mydata.shop.free_return_rate}}%+
							{{mydata.shop.exceed_rate_deduct}}%
						</div>
					</div>
				</div>
			</div>

			<div class="item" v-if="mydata.oredr_delivery && mydata.oredr_delivery.length>0">
				<div class="ohead">
					实发快递
				</div>
				<!-- <div class="ts">若未能如实反馈，买家收货有出入并引起争议时，需要承担相应的责任和损失</div> -->
				<div class="table">
					<el-table :data="mydata.oredr_delivery" style="width: 100%" border>
						<el-table-column prop="delivery_name" label="实发快递" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="delivery_num" label="快递单号" align="center" header-align="center">
						</el-table-column>
						<el-table-column label="款号" align="center" header-align="center">
							<template slot-scope="scope">
								<div v-for="(v,k) in scope.row.detail" :key="k">
									{{v.product_style_number}}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="尺码" align="center" header-align="center">
							<template slot-scope="scope">
								<div v-for="(v,k) in scope.row.detail" :key="k">
									{{v.product_size}}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="发货数量" align="center" header-align="center">
							<template slot-scope="scope">
								<div v-for="(v,k) in scope.row.detail" :key="k">
									{{v.num}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 配货中  卖家端 实发数量的和 = 总数的和-->
			<div class="item" v-if="type == 'seller' && mydata.order.order_status == 3 && this.onsun()">
				<div class="ohead">
					新增快递明细
				</div>
				<div class="itable">
					<div class="ftable">
						<div class="l1">
							<div class="form">
								<el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm"
									label-width="180px" label-position="top" size="small">
									<el-form-item label="快递" prop="delivery_id">
										<el-select v-model="ruleForm.delivery_id" placeholder="请选择快递" filterable>
											<el-option :label="v.name" :value="v.id"
												v-for="(v,k) in appdata.list.delivery" :key="k">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="快递单号" prop="delivery_num">
										<el-input v-model="ruleForm.delivery_num" placeholder="请填写快递单号"></el-input>
									</el-form-item>
								</el-form>
							</div>
						</div>
						<div class="l1 l">
							<p>勾选款号尺码数量，数量可编辑</p>
							<div class="table">
								<div class="th" v-for="(v,k) in mydata.order_detail" :key="k">
									<div class="td">{{v.product_style_number}}</div>
									<div class="td">{{v.product_size}}</div>
									<div class="td">
										<el-input-number v-model="dlist[k].num" :min="0" :max="dlist[k].max"
											size="small">
										</el-input-number>
									</div>
									<div class="td">
										<el-checkbox v-model="dlist[k].checked" :disabled="dlist[k].disabled"></el-checkbox>
									</div>
								</div>
							</div>
						</div>
						<div class="l2">
							<el-button type="primary" size="small" @click="onsub()">保存快递</el-button>
						</div>
					</div>
				</div>
			</div>

			<div class="item">
				<div class="ohead">
					收货人信息
				</div>
				<div class="itable">
					<div class="qdtable">
						<div class="lh">收货人姓名</div>
						<div class="rv">
							<div>{{mydata.order.recv_name}}</div>
							<div class="time">
								<p>订单下单时间：{{mydata.order.create_time_str}}</p>
								<p>订单付款时间：{{mydata.order.pay_time_str}}</p>
								<p>订单配货时间：{{mydata.order.peihuo_time_str}}</p>
								<p>预计发货时间：{{mydata.order.prev_time_str}}</p>
								<p>实际发货时间：{{mydata.order.send_time_str}}</p>
								<p>快递揽收时间：{{mydata.order.delivery_time_str}}</p>
							</div>
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">所属地区</div>
						<div class="rv">
							{{mydata.order.recv_province}}
							{{mydata.order.recv_city}}
							{{mydata.order.recv_area}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">详细地址</div>
						<div class="rv">
							{{mydata.order.recv_address}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">收货人电话</div>
						<div class="rv">
							{{mydata.order.recv_mobile}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">备注</div>
						<div class="rv">
							{{mydata.order.buyer_remark}}
						</div>
					</div>
					<div class="qdtable">
						<div class="lh">淘宝格式</div>
						<div class="rv" @click="oncopy(mydata.order.taobao)">
							{{mydata.order.taobao}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Orderdetails',
		data() {
			return {
				mydata: {
					buy_user: {},
					order: {},
					order_detail: [],
					oredr_delivery: [],
					shop: {}
				},

				ruleForm: {
					delivery_id: this.checkobj.delivery_id,
					delivery_num: "",
				},

				rules: {
					delivery_id: [{
						required: true,
						message: '请选择快递',
						trigger: 'change'
					}],

					delivery_num: [{
						required: true,
						message: '请填写快递单号',
						trigger: 'blur'
					}]
				},

				type: "",
				loufashow: false,
				lflist: [],
				dlist: [],
				aa: 0,
				checked: false
			}
		},

		mounted() {
			// this.objdata = this.checkobj;
			// console.log(this.objdata);
			if (this.$route.path.indexOf("seller") != -1) {
				this.type = "seller";
			} else if (this.$route.path.indexOf("buyer") != -1) {
				this.type = "buyer";
			}

			this.oninfo();
		},

		inject: ['onimgarr', 'appdata','oncopy'],

		props: {
			checkobj: {
				type: Object,
				default: {}
			},
		},

		methods: {
			oninfo() {
				var obj = {
					trade_no: this.checkobj.trade_no
				}

				this.$axios.post('api/user/order_info', obj).then(res => {
					if (res.data.code == 0) {
						// this.mydata = res.data.data;
						this.$set(this, 'mydata', res.data.data);
						if (this.mydata.order.order_status == 3) {
							this.ondetail();
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			handleChange(val, id) {
				var obj = {
					trade_no: this.checkobj.trade_no,
					detail_id: id,
					true_num: val
				};
				this.$axios.post('api/user/set_true_num', obj).then(res => {
					if (res.data.code == 0) {
						this.oninfo();
						this.$emit('odload',"");
					} else {
						this.$message.error(res.data.message);
						this.oninfo();
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onloufa() {
				this.$confirm('“修改漏发数量”只能修改提交一次，请根据真实发货情况，谨慎修改，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loufashow = true;
					this.onlflist();
				}).catch(() => {})
			},

			onlflist() {
				this.lflist = [];
				this.mydata.order_detail.forEach((v, k) => {
					var obj = {};
					obj.detail_id = v.id;
					obj.num = 0;

					this.$set(this.lflist, k, obj);
				})
			},

			oncancel() {
				this.lflist = [];
				this.loufashow = false;
			},

			onsubloufa() {
				this.$confirm('“修改漏发数量”只能修改提交一次，提交前请确认您的漏发数量?', '提示', {
					confirmButtonText: '确认提交',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: this.checkobj.trade_no,
						extra: JSON.stringify(this.lflist)
					}
					this.$axios.post('api/user/loufa', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('提交成功');
							this.oncancel();
							this.oninfo();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			onsun() {
				var num1 = 0;
				var num2 = 0;
				this.mydata.order_detail.forEach((v, k) => {
					if (v.true_num) {
						num1 = v.true_num + num1;
					}
				})

				this.mydata.oredr_delivery.forEach((v, k) => {
					if (v.detail) {
						v.detail.forEach((x, y) => {
							if (x.num) {
								num2 = x.num + num2;
							}
						})
					}
				})
				if (num1 > num2) {
					return true;
				} else {
					return false;
				}
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var arr = [];
						if (this.dlist.length > 0) {
							this.dlist.forEach((v, k) => {
								if (v.checked) {
									arr.push(v)
								}
							})
						}

						if (arr.length == 0) {
							this.$message.warning("至少勾选一条数据");
							return;
						}
						var detail = JSON.stringify(arr);
						var obj = JSON.parse(JSON.stringify(this.ruleForm))
						obj.trade_no = this.checkobj.trade_no;
						obj.detail = detail;
						this.$axios.post('api/user/set_multi_delivery', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.ruleForm.delivery_id = this.checkobj.delivery_id;
								this.ruleForm.delivery_num = "";
								this.oninfo();
								this.$emit('odload',"");
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			ondetail() {
				var arr = [];
				// this.dlist
				this.mydata.order_detail.forEach((v, k) => {
					var obj = {};
					obj.product_style_number = v.product_style_number;
					obj.product_size = v.product_size;
					obj.num = v.true_num;
					obj.checked = false;
					obj.disabled = false;
					obj.max = v.true_num;
					if(this.mydata.oredr_delivery && this.mydata.oredr_delivery.length > 0) {
						this.mydata.oredr_delivery.forEach((x,y)=>{
							if(x.detail && x.detail.length>0) {
								x.detail.forEach((a,b)=>{
									if(v.product_size == a.product_size && v.product_style_number == a.product_style_number){
										obj.max = obj.max-a.num;
										obj.num = obj.max;
									}
								})
							}
						})
					}
					if(obj.num == 0 && obj.max == 0) {
						obj.disabled = true;
					}
					arr.push(obj);
				})
				this.$set(this, 'dlist', arr);
			},
			
			tableRowClassName({row,rowIndex}) {
				var n = row.num ? row.num:0;
				var t = row.true_num ? row.true_num:0;
				if (n > t) {
					return "yellor_row"
				}
				return ""
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 33%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:last-child {
			border-right: none;
		}
	}

	.otitle1 {
		div {
			width: 20%;
		}

		div:first-child {
			width: 40%;
		}
	}

	.img {
		width: 60px;
	}

	.item {
		width: 100%;
		margin-bottom: 10px;

		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;

			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}

		.red {
			background-color: #cc3300 !important;
			color: #fff !important;
			border: 1px solid #cc3300 !important;
		}

		.qdtable {
			width: 100%;
			display: flex;
			font-size: 14px;

			>div {
				min-height: 40px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EBEEF5;
			}

			.lh {
				width: 180px;
				min-width: 180px;
				justify-content: center;
				border-right: 1px solid #EBEEF5;
			}

			.rv {
				width: 100%;
				padding-left: 10px;
				display: flex;

				div {
					width: 50%;
				}

				.time {
					padding: 9px;
					border-left: 1px solid #EBEEF5;

					p {
						line-height: 20px;
					}
				}

			}
		}

		.itable {
			border: 1px solid #EBEEF5;
			border-bottom: none;
		}

		.ftable {
			display: flex;
			align-items: center;
			border-bottom: 1px solid #EBEEF5;

			.l {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				padding: 10px;
				box-sizing: border-box;
			}

			.l1 {
				width: 50%;
				height: 100%;

				.form {
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				/deep/ .el-form-item__label {
					width: 100%;
					text-align: center;
				}

				.table {
					width: 100%;
					// height: 100%;
					border-top: 1px solid #EBEEF5;
					border-left: 1px solid #EBEEF5;

					.th {
						display: flex;
						align-items: center;
						border-bottom: 1px solid #EBEEF5;
						height: 45px;

						/deep/ .el-input-number {
							width: 110px !important;
						}

						/deep/ .el-input__inner {
							padding-left: 30px !important;
							padding-right: 30px !important;
						}

						.td {
							width: 50%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							border-right: 1px solid #EBEEF5;
							padding: 6px 0;
							box-sizing: border-box;
						}

						.td:nth-child(2) {
							width: 80px;
							min-width: 40px;
						}

						.td:nth-child(3) {
							width: 40%;
							min-width: 40px;
						}

						.td:nth-child(4) {
							width: 40px;
							min-width: 40px;
						}
					}
				}

				p {
					margin-bottom: 10px;
				}
			}

			.l1:nth-child(2) {
				border-left: 1px solid #EBEEF5;
				border-right: 1px solid #EBEEF5;
			}

			.l2 {
				min-width: 100px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

	.ts {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #ff4714;
		font-size: 14px;
		height: 30px;
	}

	.statistics {
		margin: 10px 0 30px;
		font-size: 14px;
	}

	.btns {
		width: 100%;
		padding: 0px 0 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-end;
	}

	/deep/ .lf {
		background-color: #cc3300 !important;
		color: #fff !important;
	}
	
	// /deep/ .default1 {
	// 	background-color: #f8f8fa !important;
	// }
</style>



// WEBPACK FOOTER //
// src/common/orderdetails.vue